import React from 'react';
import { connect } from 'react-redux';
import { Form as  FormFinal, Field } from 'react-final-form';
import { Button, Table, Alert, Card, Form, Col, Spinner } from 'react-bootstrap';
import ReactDragListView from 'react-drag-listview';

import { Drag } from '@styled-icons/fluentui-system-filled/Drag';
import { CommentEdit } from '@styled-icons/boxicons-regular/CommentEdit';

//Actions
import { pesquisa, novoatualiza, atualizaPesquisa } from '../../../../actions/questionario/respostas';

//Components
import { campotexto, camporadio, camposelect } from '../../../../components/forms/campos/campos';

//Utils
import { getEvento } from '../../../../utils/eventosession';
import { getDadosToOptionsSemTrad } from '../../../../components/forms/utils/toolsforms'

//Helpers
import { TelaModalLivre } from '../../../../helpers/TelaModal';
import Bodychildren from '../../../../utils/Bodychildren';

class FormPergRespCadastroRespostas extends React.Component {

    state = {        
        perguntarespostasedicao: false
    }
    
    async componentDidMount(){
        const evento = getEvento();
        await this.props.pesquisa({
            idpromotora: evento.idpromotora, 
            idpergunta: this.props.cadastros.idpergunta,
            idevento: evento.idevento            
        });
    }

    handleSubmit = async (form) => {
        const evento = getEvento();

        const cadupdate = {
            idpromotora: evento.idpromotora, 
            idevento: evento.idevento,
            idpergunta: this.props.cadastros.idpergunta,
            ...form
        }

        await this.props.novoatualiza(cadupdate);

        await this.props.pesquisa({
            idpromotora: evento.idpromotora, 
            idevento: evento.idevento,      
            idpergunta: this.props.cadastros.idpergunta,      
        });
    }
        
    handleModalCadastro = (form) => {
        form.reset();
        this.setState({
            perguntarespostasedicao: false
        });
    }
    
    handleCadastroResposta = (resposta) => {        
        if(resposta === false){
            this.setState({
                perguntarespostasedicao: resposta
            });
            return false;
        } 
        
        let dados = {};
        if(Object.keys(resposta).length){
            dados = {
                idconteudopergunta: resposta.idconteudopergunta?resposta.idconteudopergunta:0,
                portugues: resposta.portugues,
                ingles: resposta.ingles,
                espanhol: resposta.espanhol,
                setar: `${resposta.setar}`,
                tipo: resposta.tipo,
                outrosespecificar: resposta.outrosespecificar,
                mostra: resposta.mostra,                
                mostraperg: resposta.mostraperg,
                checked: resposta.checked
            }            
        }
        this.setState({
            perguntarespostasedicao: dados
        });
    }
                
    render() {

        const cadastros = this.props.cadastrosPesquisa.length?this.props.cadastrosPesquisa:this.props.cadastros.resposta;

        const that = this;
        const dragProps = {
        async onDragEnd(fromIndex, toIndex) {

            const data = [...that.props.cadastrosPesquisa];
            const item = data.splice(fromIndex, 1)[0];
            data.splice(toIndex, 0, item);
            
            const evento = getEvento();

            await that.props.novoatualiza({
                idpromotora: evento.idpromotora, 
                idevento: evento.idevento,
                codigo: `${toIndex+1}`.padStart(3,'0'), 
                idconteudopergunta: item.idconteudopergunta,
                idpergunta: that.props.cadastrosPesquisa[toIndex].idpergunta
            });

            await that.props.novoatualiza({
                idpromotora: evento.idpromotora, 
                idevento: evento.idevento,
                codigo: `${fromIndex+1}`.padStart(3,'0'), 
                idconteudopergunta: that.props.cadastrosPesquisa[toIndex].idconteudopergunta,
                idpergunta: that.props.cadastrosPesquisa[toIndex].idpergunta
            });
        
            that.props.atualizaPesquisa(data);
            },
            nodeSelector: 'tr',
            handleSelector: 'a'
        };   

        return (
            <>            
            <FormFinal
            onSubmit={this.handleSubmit}
            initialValues={this.state.perguntarespostasedicao}
            validate={values => {
                const errors = {};

                if(!values.portugues){
                    errors.portugues = 'Obrigatório';
                }

                if(!values.setar){
                    errors.setar = 'Obrigatório';
                }

                if(!values.outrosespecificar){
                    errors.outrosespecificar = 'Obrigatório';
                }

                if(!values.mostra){
                    errors.mostra = 'Obrigatório';
                }
                                
                return errors;
            }}
            render={({ submitting, pristine, form, handleSubmit, submitSucceeded }) => {
                this.formfinal = form;                
                const gravou = submitSucceeded&&this.props.cadupdated&&this.props.cadupdated.idpergunta?true:false;
                if(gravou){
                    return (
                        <TelaModalLivre show={gravou} handleCloseModal={() => this.handleModalCadastro(form)}>
                            <Alert variant="success">Cadastro Feito com Sucesso</Alert>
                        </TelaModalLivre>
                    )
                }
                return (
                    <form onSubmit={handleSubmit}>            
                        <ReactDragListView {...dragProps}>
                            <ol>
                                <Table striped bordered hover style={{paddingBottom: '10px', marginBottom: '10px'}}>
                                    <thead>
                                        <tr>
                                            <th colSpan="5" className="text-center">Respostas</th>
                                        </tr>
                                        <tr>
                                            <th>Português</th>                                
                                            <th>Inglês</th>
                                            <th>Espanhol</th>
                                            <th>Editar</th>
                                            <th>Ordem</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {cadastros.length?cadastros.map((itens, indice) => {
                                            return (                                                
                                                <tr key={indice} style={{listStyle: "none"}}>
                                                    <td className="text-break">
                                                        {itens.portugues}
                                                    </td>
                                                    <td className="text-break">
                                                        {itens.ingles}
                                                    </td>
                                                    <td className="text-break">
                                                        {itens.espanhol}
                                                    </td>
                                                    <td className="text-right">
                                                        <CommentEdit size="35" style={{cursor: "pointer"}} onClick={() => this.handleCadastroResposta(itens)} />                                                        
                                                    </td>
                                                    <td className="text-right">                                                        
                                                        <a href="#" title="Reordenar"><Drag size="35" /></a>
                                                    </td>
                                                </tr>
                                            )                                    
                                        })
                                        :
                                        null
                                    }                                         
                                    </tbody>                            
                                </Table>
                            </ol>   
                        </ReactDragListView>
                        {this.state.perguntarespostasedicao!==false?
                        <Card style={{maxWidth: "100%"}}>
                            <Card.Body>
                                <Field type="hidden" name="idconteudopergunta" component={campotexto} />
                                <Form.Row>
                                    <Form.Group as={Col} md="4" controlId="tipo">
                                        <Field label="Tipo" name="tipo" component={camposelect}
                                        options={[{'value': 1, 'texto': 'Comum'}, {'value': 2,'texto': 'Nome de Empresa'}]}
                                        />
                                    </Form.Group>
                                </Form.Row>
                                <Form.Row>
                                    <Form.Group as={Col} md="4" controlId="portugues">
                                        <Field type="textarea" label="Português" name="portugues" placeholder="Português" component={campotexto}/>
                                    </Form.Group>
                                    <Form.Group as={Col} md="4" controlId="ingles">
                                        <Field type="textarea" label="Inglês" name="ingles" placeholder="Inglês" component={campotexto} />
                                    </Form.Group>
                                    <Form.Group as={Col} md="4" controlId="espanhol">
                                        <Field type="textarea" label="Espanhol" name="espanhol" placeholder="Espanhol" component={campotexto} />
                                    </Form.Group>
                                </Form.Row>
                                <Form.Row>                                    
                                                                        
                                </Form.Row>
                                <Form.Row>
                                    <Form.Group as={Col} md="4" controlId="checked">
                                        <Card.Header>Marcado</Card.Header>
                                        <Field type="radio" label="Sim" name="checked" value="S" component={camporadio} />
                                        <Field type="radio" label="Não" name="checked" value="N" component={camporadio} />
                                    </Form.Group>                                                                        
                                </Form.Row>
                                <Form.Row>                                
                                    <Form.Group as={Col} md="4" controlId="setar">
                                        <Card.Header>Setar</Card.Header>
                                        <Field type="radio" label="Sim" name="setar" value="0" component={camporadio} />
                                        <Field type="radio" label="Não" name="setar" value="1" component={camporadio} />
                                    </Form.Group>                             
                                    <Form.Group as={Col} md="4" controlId="outrosespecificar">
                                        <Card.Header>Especificar</Card.Header>
                                        <Field type="radio" label="Sim" name="outrosespecificar" value="S" component={camporadio} />
                                        <Field type="radio" label="Não" name="outrosespecificar" value="N" component={camporadio} />
                                    </Form.Group>
                                    <Form.Group as={Col} md="4" controlId="mostra">
                                        <Card.Header>Mostrar</Card.Header>
                                        <Field type="radio" label="Sim" name="mostra" value="S" component={camporadio} />
                                        <Field type="radio" label="Não" name="mostra" value="N" component={camporadio} />
                                    </Form.Group>
                                </Form.Row>                                
                                <Form.Row>                                    
                                    <Form.Group as={Col} md="8" controlId="mostraperg">                                        
                                        <Field label="Mostra Pergunta"
                                        options={ getDadosToOptionsSemTrad(this.props.perguntas.concat({idpergunta: 0, portugues: '*Sem Sub-Pergunta*'}),'idpergunta','portugues','Perguntas')}
                                        name="mostraperg" 
                                        component={camposelect} />                                        
                                    </Form.Group>
                                </Form.Row>
                                <Button type="submit" disabled={pristine || submitting} className="mr-2">
                                    Confirmar
                                </Button>
                                <Button type="button" onClick={() => this.handleCadastroResposta(false)}>
                                    Cancelar
                                </Button>
                            </Card.Body>
                        </Card>
                        :
                        <Table striped bordered hover style={{bottom: '50px', maxWidth: "100%"}}>
                            <tbody>                                
                                <tr>
                                    <td className="text-right" colSpan="3">
                                        <Button type="button" onClick={() => this.handleCadastroResposta({})}>
                                            Nova Resposta
                                        </Button>
                                    </td>
                                </tr>                                          
                            </tbody>
                        </Table>
                        }
                    </form>
                )
            }}
            />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {        
        pendingTasks: state.pendingTasks,
        cadupdated: state.respCadAtualizaReducer,        
        cadastrosPesquisa: state.respostasPesquisaReducer
    }
}

export default connect(mapStateToProps, { pesquisa, novoatualiza, atualizaPesquisa })(FormPergRespCadastroRespostas);